import { render, staticRenderFns } from "./InputDownloadComponent.vue?vue&type=template&id=16572227"
import script from "./InputDownloadComponent.vue?vue&type=script&lang=js"
export * from "./InputDownloadComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/InputDownloadComponent.vue
// module id = null
// module chunks = 